// hooks/requests/t2pay/use-get-talk2pay-fees.ts

import useSWR from "swr";

import SWR_KEYS from "@/constants/swr-keys";
import { Talk2PayFees } from "@/interfaces/talk2pay.iterfaces";
import t2payService from "@/services/t2pay.service";
import { RequestsBaseReturn } from "@/types/requests.types";

export type UseGetTalk2PayFeesReturn = RequestsBaseReturn<Talk2PayFees | null>;

const useGetTalk2PayFees = (): UseGetTalk2PayFeesReturn => {
  const {
    data = null,
    isValidating: isLoading,
    error,
  } = useSWR<Talk2PayFees, Error>(SWR_KEYS.getTalk2PayFees, () => t2payService.getTalk2PayFees(), {
    revalidateOnFocus: false,
  });

  return { data, isLoading, error };
};

export default useGetTalk2PayFees;
